<template>
  <div>
    <div class="row pt-2 first-search-holder">
      <div class="col-12 first-search px-0">
        <div class="row h-100 no-gutters">
          <div class="col px-0">
            <input
              v-validate="'required'"
              name="title"
              readonly
              type="text"
              placeholder="Title"
              v-model=getName
            />
          </div>
          <div class="col px-0">
            <input
              v-validate="'required'"
              name="code"
              type="text"
              placeholder="Code"
              v-model="service.code"
            />
          </div>
          <div class="col">
            <core-drop-down
              :items="providers"
              v-if="providers.length || service.id"
              noWrapper
              :selectedValue.sync="service.providerId"
              searchable
            ></core-drop-down>
          </div>
          <div class="col">
            <input
              min="0" max="100" step="0.1"
              name="commission"
              type="number"
              placeholder="Commission (%)"
              v-model=service.commission
            />
          </div>
          <div class="col">
            <core-drop-down
              :items="taxes"
              v-if="taxes.length || service.id"
              noWrapper
              :selectedValue.sync="service.taxId"
            ></core-drop-down>
          </div>
          <div class="col-2">
            <core-drop-down
              searchable
              :items="countries"
              :labelAttribute="'name_' + $i18n.locale.toUpperCase()"
              v-if="countries.length"
              :selectedValue.sync="service.country"
            ></core-drop-down>
          </div>
          <div class="col">
            <core-drop-down
              :items="cities"
              v-if="isLoaded"
              :labelAttribute="'name_' + $i18n.locale.toUpperCase()"
              :selectedValue.sync="service.city"
              searchable
            ></core-drop-down>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-8">
        <core-lever
          wrapperClass="mr-2"
          :label="$t('services.info.navigation.info.3rd-party-api')"
          labelClass="ml-1"
          v-model="service.externalApi"
          labelPosition="right"
        ></core-lever>
        <core-lever
          wrapperClass="mr-2"
          :label="$t('services.info.navigation.info.aut-mail-on-booking')"
          v-model="service.autoMail"
          labelClass="ml-1"
          labelPosition="right"
        ></core-lever>
        <core-lever
          :label="$t('services.info.navigation.info.stop')"
          v-model="service.active"
          labelPosition="right"
          labelClass="ml-1"
          inverted
        ></core-lever>
        <core-lever
          :label="$t('services.info.navigation.info.auto-booking')"
          v-model="service.autoBooking"
          labelPosition="right"
          labelClass="ml-1"
        ></core-lever>
        <core-lever
          :label="$t('services.info.navigation.info.action-dates-available')"
          v-model="service.actionDateDenied"
          labelPosition="right"
          labelClass="ml-1"
        ></core-lever>
      </div>
      <div class="col-4 d-flex justify-content-end align-items-center pr-5">
        <span class="show-buyer">{{
          $t('services.info.navigation.info.show-customer')
        }}</span>
        <core-lever
          wrapperClass="ml-2"
          :label="$t('services.info.navigation.info.prices')"
          labelClass="ml-1"
          v-model="service.showPrices"
        ></core-lever>
        <core-lever
          wrapperClass="ml-2"
          :label="$t('services.info.navigation.info.times')"
          labelClass="ml-1"
          v-model="service.showTimes"
        ></core-lever>
        <core-lever
          wrapperClass="ml-2"
          :label="$t('services.info.navigation.info.action')"
          labelClass="ml-1"
          v-model="service.showActions"
        ></core-lever>
      </div>
    </div>
    <div class="row form my-5 ml-1">
      <div class="col-lg-12">
        <div class="row" v-if="service.externalApi && service.externalApi !== '0' && service.serviceType.code === 'ACCOMMODATION'">
          <div class="input__container pb-2 mb-4 col-lg-4 has-line">
<!--            <span class="hotel-name">{{ service.title_NL }}</span>-->
            <div class="slot-container">
              <core-beds-hotel-searcher
                :value=parseInt(service.bedsHotelCode)
                :entity="service" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="input__container pb-2 mb-4 col-lg-4 has-line" style="border-bottom: 1px solid #dddddd;">
<!--            <span class="hotel-name">{{ service.title_NL }}</span>-->
            <div class="slot-container">
              <core-lang-field-editor
                fieldName='title'
                :entity="service" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 input-group pb-2 mb-4 currency">
            <div class="col-lg-12 px-0">
              <div class="row">
                <div class="col-lg-9">
                  <span>{{
                    $t('services.info.navigation.info.currency')
                  }}</span>
                </div>
                <div class="col-lg-3">
                  <core-basic-drop-down
                    v-if="currencies.length"
                    :items="currencies"
                    labelAttribute="code"
                  ></core-basic-drop-down>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="service.serviceType && service.serviceType.code === 'TRANSPORT'">
          <core-floating-label
            :config="{
              label: this.$t('services.info.navigation.info.duration'),
              name: 'duration',
              hasClearButton: false
            }"
          >
            <input name="duration" type="number" min="0" v-model="service.duration" />
          </core-floating-label>
        </div>
        <div class="row">
          <core-floating-label
            :config="{
              label: service.email ? '' : this.$t('services.info.navigation.info.email'),
              name: 'email',
              hasClearButton: false
            }"
          >
            <input name="email" type="text" v-model="service.email" />
          </core-floating-label>
        </div>
        <div class="row">
          <core-floating-label
            :config="{
              label: service.phoneNumber ? '' : this.$t('services.info.navigation.info.phone-number'),
              name: 'phone',
              hasClearButton: false
            }"
          >
            <input name="phone" type="text" v-model="service.phoneNumber" />
          </core-floating-label>
        </div>
        <div class="row">
          <core-floating-label
            :config="{
              label: service.latitude ? '' : this.$t('services.info.navigation.info.address'),
              name: 'address',
              hasClearButton: false
            }"
          >
            <input name="address" type="text" v-model="service.latitude" />
          </core-floating-label>
        </div>
        <div class="row">
          <div class="col-lg-4 pb-2 currency">
            <div class="col-lg-12 px-0">
              <div class="row">
                <core-floating-label
                  :config="{
                    label: service.iban ? '' : this.$t('services.info.navigation.info.iban'),
                    name: 'iban',
                    hasClearButton: false
                  }"
                  class="col-lg-8"
                >
                  <input name="iban" type="text" v-model="service.iban" />
                </core-floating-label>
                <core-floating-label
                  :config="{
                    label: service.bic ? '' : this.$t('services.info.navigation.info.bic'),
                    name: 'bic',
                    hasClearButton: false
                  }"
                >
                  <input name="bic" type="text" v-model="service.bic" />
                </core-floating-label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 pb-2 mb-4 currency">
            <div class="col-lg-12 px-0">
              <div class="row">
                <core-drop-down
                  wrapperClass="border-bottom border-light pl-2"
                  searchable
                  :placeholder="this.$t('services.info.navigation.info.ledger')"
                  :items="ledgers"
                  labelAttribute="name"
                  valueAttribute="id"
                  v-if="ledgers.length"
                  :selectedValue.sync="service.turnoverLedger"
                ></core-drop-down>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <core-floating-label
            :config="{
              label: service.absoluteBookingLink ? '' : this.$t('services.info.navigation.info.absolute-booking-link'),
              name: 'email',
              hasClearButton: false
            }"
          >
            <input name="absoluteBookingLink" class="col-10" type="text" v-model="service.absoluteBookingLink" />
          </core-floating-label>
        </div>
        <div class="row">
          <core-floating-label
            :config="{
              label: service.relativeBookingLink ? '' : this.$t('services.info.navigation.info.relative-booking-link'),
              name: 'email',
              hasClearButton: false
            }"
          >
            <input name="relativeBookingLink" class="col-10" type="text" v-model="service.relativeBookingLink" />
          </core-floating-label>
        </div>
        <div class="row">
          <core-floating-label
            :config="{
              label: service.daysBeforeBooking ? '' : this.$t('services.info.navigation.info.days-before-booking'),
              name: 'daysBeforeBooking',
              hasClearButton: false
            }"
          >
            <input name="daysBeforeBooking" class="col-10" type="number" v-model="service.daysBeforeBooking" />
          </core-floating-label>
        </div>
        <div class="row" v-if="service.serviceType && service.serviceType.code === 'TRANSPORT' && 0">
          <core-floating-label
            :config="{
              label: service.defaultDepartureTime ? '' : this.$t('services.info.navigation.info.default-departure-time'),
              name: 'defaultDepartureTime',
              hasClearButton: false
            }"
          >
            <input name="defaultDepartureTime" class="col-10" type="text" v-model="service.defaultDepartureTime" />
          </core-floating-label>
        </div>
        <div class="row">
          <core-floating-label
            :config="{
              label: service.externalName ? '' : this.$t('services.info.navigation.info.external-name'),
              name: 'externalName',
              hasClearButton: false
            }"
          >
            <input name="externalName" class="col-10" type="text" v-model="service.externalName" />
          </core-floating-label>
        </div>
        <div class="row">
          <div class="col-lg-4 input-group pb-2 mb-4 currency">
            <div class="col-lg-12 px-0">
              <div class="row">
                <div class="col-lg-8">
                  <span>{{
                      $t('services.info.navigation.info.price-provider')
                    }}</span>
                </div>
                <div class="col-lg-4">
                  <select
                    v-model="service.priceProviderId"
                    class="right-chevron"
                  >
                    <option :value="null">{{ $t('general.none') }}</option>
                    <option v-for="priceProvider in priceProviders" :value="priceProvider.id" :key="priceProvider.code">
                      {{ priceProvider.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Service from '@/services/hatsApi/Service'
import Geo from '@/services/hatsApi/Geo'
import Currency from '@/services/hatsApi/Currency'
import Ledger from '@/services/hatsApi/Ledger'
import PriceProvider from '@/services/hatsApi/PriceProvider'

export default {
  data () {
    return {
      providers: [{ id: 1, name: 'Direct' }, { id: 2, name: 'Sunair' }],
      commissions: [
        { id: 1, name: '10%' },
        { id: 2, name: '20%' },
        { id: 3, name: '30%' },
        { id: 4, name: '40%' }
      ],
      taxes: [
        { id: 1, name: 'Geen BTW' },
        { id: 2, name: '6%' },
        { id: 3, name: '21%' }
      ],
      serviceTypes: [],
      countries: [],
      cities: [],
      currencies: [],
      ledgers: [],
      priceProviders: []
    }
  },
  props: {
    service: {
      default: () => ({}),
      type: Object,
      required: true
    }
  },
  computed: {
    isLoaded () {
      return (
        this.serviceTypes.length &&
        this.countries.length &&
        this.cities.length &&
        this.currencies.length &&
        this.priceProviders.length
      )
    },
    getName () {
      return this.service['title_' + this.$i18n.locale.toUpperCase()]
    }
  },
  created () {
    // TODO: remove on BE
    this.service.turnoverLedger = this.service.ledgerTurnover
    delete this.service.ledgerTurnover

    Ledger.getLedgersForDropdown().then(response => {
      this.ledgers = response.data.data
    })
    Service.getServiceTypes().then(response => {
      this.serviceTypes = response.data.data
    })
    Geo.getCountries().then(response => {
      this.countries = response.data.data
    })
    Geo.getCities().then(response => {
      this.cities = response.data.data
    })
    Currency.getCurrencies().then(response => {
      this.currencies = response.data.data
    })
    PriceProvider.getPriceProviders().then(response => {
      this.priceProviders = response.data.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/service/Info.vue